<template>
  <div>
    <template v-for="(category, index) in modifiersByCategories">
      <template v-for="(modifier, newIndex) in category.modifiers">
        <template v-if="modifier.is_radio_type">
          <span style="display: block">{{ modifier.name }}</span>
        </template>
        <template v-else>
          <span>{{ modifier.name }}
            <template v-if="modifier.categoryNew.max_qty_modifier > 1">
              <img :src="require('@/assets/img/facebook/x.svg')" alt="x"> {{modifier.count}}
            </template>
          </span>
        </template>
      </template>
    </template>
  </div>
</template>

<script>
  export default {
    name: 'ReceiptOptions',
    props: [
      'product'
    ],
    computed: {
      modifiersByCategories() {
        let categories = []
        if (this.product.modifiers) {
          this.product.modifiers.forEach((modifier) => {
            if (modifier.selected) {
              if (categories.every((category) => {
                return category.name !== modifier.category
              })) {
                categories.push({'name': modifier.category, 'modifiers': [modifier]})
              } else {
                categories.forEach((category, index) => {
                  if (category.name === modifier.category) {
                    categories[index].modifiers.push(modifier)
                  }
                })
              }
            }
          })
        }
        return categories
      }
    }
  }
</script>
